import { ISiteDTO } from "@/Administration/Api/Dto/Sites/ISiteDTO";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { SitesUIState } from "@/Common/Models/UI/Enums";

type Sites = "Sites";
type ParentSites = "ParentSites";
type UIStateChange = "UIStateChange";
type SearchText = "SearchText";
type IsDuplicateWarningOpen = "IsDuplicateWarningOpen";
type DuplicateDto = "DuplicateDto";

interface ISitesTabModel {
    get(key: Sites): Immutable.List<SitesModel>;
    set(key: Sites, value: Immutable.List<SitesModel>): this;

    get(key: ParentSites): Immutable.List<SitesModel>;
    set(key: ParentSites, value: Immutable.List<SitesModel>): this;

    get(key: UIStateChange): SitesUIState;
    set(key: UIStateChange, value: SitesUIState): this;

    get(key: SearchText): string;
    set(key: SearchText, value: string): this;

    get(key: IsDuplicateWarningOpen): boolean;
    set(key: IsDuplicateWarningOpen, value: boolean): this;

    get(key: DuplicateDto): ISiteDTO;
    set(key: DuplicateDto, value: ISiteDTO): this;
}

class SiteTabModel {
    public static getDefault(): any {
        return Immutable.fromJS({
            Sites: [],
            ParentSites: [],
            SearchText: "",
            IsDuplicateWarningOpen: false
        });
    }
}

export { ISitesTabModel, SiteTabModel };
